<div class="encabezado">
  <div class="">
    <div class="">
      <div>
        <h5 class="titulo1">{{ "titles-menu-pages.clients" | translate }}</h5>
      </div>
    </div>
    <!-- end card body -->
  </div>
  <div class="row">
    <div class="col-8">
      <app-shared-filter (filterChanged)="filterChanged($event)" [type]="'clients'"></app-shared-filter>
    </div>
    <div class="col-4">
      <div class="btn-izq">
        <button class="btn btn-hover" type="button" (click)="toggleForm()">
          <span class="add-btn-text">{{ "buttons.add+" | translate }}</span> <i class="icon-plus"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="tabla">
    <mat-paginator [length]="paginator.length ? paginator.length : 25" [pageSize]="paginator.pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]" [hidePageSize]="true" (page)="onPageChange($event)">
    </mat-paginator>

    <!-- Desktop: tabla mat-table -->
    <div class="table-responsive-wrapper">
    <div class="table-scroll-inner">
    <table mat-table [dataSource]="dataSource" matSort class="full-width-table" aria-label="Clients">
      <ng-container matColumnDef="tax_id">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.tax_id" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.tax_id }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.type" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{
          row.type === 'individual'
          ? 'Particular'
          : (row.type === 'self-employed'
          ? 'Autónomo'
          : (row.type === 'organization'
          ? 'Empresa'
          : row.type))
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.name" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.type === 'organization' ? row.name : (row.name + (row.lastname ? ' ' + row.lastname : '')) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.email" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.phone" | translate }}
        </th>
        <td mat-cell *matCellDef="let row"><span *ngIf="row.phone">{{ row.phone }}</span></td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="cabecera-tabla">
          {{ "inputs.actions" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <i class="icon-pencil text-success icon-actions" (click)="editClient(row.reference,'general')"></i>
          <i *ngIf="!row.has_order && !row.is_assignee" class="icon-trash text-danger icon-actions"
            (click)="deleteClient(row.reference)"></i>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    </div>
    </div>

    <!-- Mobile: card layout -->
    <div class="cards-mobile-wrapper">
      <div *ngFor="let row of dataSource.data" class="client-card" (click)="editClient($any(row).reference,'general')">
        <div class="card-header-row">
          <span class="card-name">
            {{ $any(row).type === 'organization' ? row.name : (row.name + (row.lastname ? ' ' + row.lastname : '')) }}
          </span>
          <span class="card-type-badge" [ngClass]="{
            'badge-organization': $any(row).type === 'organization',
            'badge-individual': $any(row).type === 'individual',
            'badge-self-employed': $any(row).type === 'self-employed'
          }">
            {{ $any(row).type === 'individual' ? 'Particular'
              : ($any(row).type === 'self-employed' ? 'Autónomo'
              : ($any(row).type === 'organization' ? 'Empresa' : $any(row).type)) }}
          </span>
        </div>
        <div class="card-body-content">
          <span class="card-detail"><i class="icon-vcard" aria-hidden="true"></i> {{ row.tax_id }}</span>
          <span *ngIf="row.email" class="card-detail"><i class="icon-envelope" aria-hidden="true"></i> {{ row.email }}</span>
          <span *ngIf="row.phone" class="card-detail"><i class="icon-phone" aria-hidden="true"></i> {{ row.phone }}</span>
        </div>
        <div class="card-footer-row">
          <div class="card-actions">
            <i class="icon-pencil text-success icon-actions" (click)="editClient($any(row).reference,'general'); $event.stopPropagation()" aria-hidden="true"></i>
            <i *ngIf="!$any(row).has_order && !$any(row).is_assignee" class="icon-trash text-danger icon-actions"
              (click)="deleteClient($any(row).reference); $event.stopPropagation()" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <mat-paginator [length]="paginator.length" [pageSize]="paginator.pageSize"
      [pageSizeOptions]="paginator.pageSizeOptions" (page)="onPageChange($event)">
    </mat-paginator>

  </div>
</div>

<div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showForm }">
  <app-form-add-client (backButtonClick)="cerrarFormulario()" (addClient)="refreshClients()"
    (clientDuplicateFound)="openClientForm($event)" (emitOpenAssigneeCreateForm)="openAssigneeCreateForm()"
    (backButtonClickAndEdit)="cerrarFormularioAddAndEdit($event)"
    (assigneeCreated)="handleNewAssigneeInClients($event)">
  </app-form-add-client>
</div>

<div class="formulario-sub-derecha-container" [ngClass]="{'mostrar-formulario': showAssigneeCreateForm }">
  <app-form-add-assignee *ngIf="showAssigneeCreateForm" (assigneeCreated)="handleNewAssigneeInClients($event)"
    [document_buttons_chico]="document_buttons_chico" (clientDuplicateFound)="openClientForm($event)"
    (emitOpenAssigneeCreateForm)="openAssigneeCreateForm()" (closeAssigneeCreateForm)="closeAssigneeCreateForm()"
    (backButtonClick2)="cerrarFormulario2()"></app-form-add-assignee>
</div>

<div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showFormEdit }">
  <app-form-edit-client *ngIf="showFormEdit" [clientData]="client_reference" [tab]="tab"
    (backButtonClickEdit)="cerrarFormularioEdit()" (clientUpdated)="onClientUpdated()"
    (emitOpenAssigneeForm)="openAssigneeForm($event)" (emitCloseClientForm)="closeClientForm()"
    (emitCloseAssigneeForm)="closeAssigneeForm()" [document_buttons_chico]="document_buttons_chico"
    (emitOpenClientForm)="openClientForm(client_reference)" (emitOpenOrderForm2)="openAddOrderForm2($event, ladata)"
    (clientUpdated2)="refreshClientData()"></app-form-edit-client>
</div>

<div class="formulario-sub-derecha-container" [ngClass]="{'mostrar-formulario': showAssigneeForm }">
  <app-form-show-assignee *ngIf="showAssigneeForm" (backButtonClick)="cerrarAssigneeFormulario()"
    [assignee]="assignee" (addClient)="refreshClients()" [ladata]="ladata">
  </app-form-show-assignee>
</div>

<div class="formulario-sub-derecha-container" [ngClass]="{'mostrar-formulario': showAddOrderForm }">
  <app-form-add-orders [clientData]="clientData" [client_reference]="client_reference" [openedFromClients]="true"
    [ladata]="ladata" (openOrderFormFromClients2)="openAddOrderForm2(client_reference, ladata)"
    (emitOpenOrderForm2)="openAddOrderForm2(client_reference, ladata)" (backButtonClick2)="cerrarFormularioAddOrder()"
    [clientName]="clientTitle" [formAddOrderOpened2]="showAddOrderForm">
  </app-form-add-orders>
</div>

<div class="overlay" *ngIf="showForm || showFormEdit || showAddOrderForm || showAssigneeCreateForm"
  (click)="cerrarFormulario()"></div>
